import * as React from 'react';
import Button from '@mui/material/Button';

export default function BasicButtons({title, handleAction, style}) {
    return (
        <Button style={{maxHeight: "3rem"}} variant="contained" onClick={handleAction}>{title}</Button>
    );
}
